export const purePriceValue = (price) => {
	return parseInt(Math.ceil(parseFloat(price)), 10)
}

export const asCurrencyValue = (v) => {
	if (v) {
		return String(v).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
	}
}